import { render } from "./CustomSlider.vue?vue&type=template&id=0b75f4e9&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"

import "./CustomSlider.vue?vue&type=style&index=0&id=0b75f4e9&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b75f4e9"]])

export default __exports__